<template>
  <div class="client-individual-editor client-row">
    <v-card>
      <v-card-text class="clientEditForm client-edit-form">
        <v-container>
          <v-tabs v-model="activeSectionIndex" slider-color="primary">
            <v-tab id="tabGeneral" :value="0" ripple text="General" max-height="40" />
            <v-tab
              id="tabExcursionManagement"
              :value="1"
              ripple
              text="Excursion Management"
              max-height="40"
            />
            <v-tab id="tabProviders" :value="2" ripple text="Providers" max-height="40" />
            <v-tab id="tabContentEngine" :value="3" ripple text="Content Engine" max-height="40" />
            <v-tab
              id="tabStudentManagement"
              :value="4"
              ripple
              text="Student Management"
              max-height="40"
            />
            <v-tab id="tabTemplates" :value="5" ripple text="Templates" max-height="40" />
            <v-tab id="tabHubMigration" :value="6" ripple text="Hub Integration" max-height="40" />
          </v-tabs>
          <v-tabs-window v-model="activeSectionIndex" class="px-2">
            <v-tabs-window-item :value="0">
              <div class="client-row client-modal-text">
                <client-general
                  ref="refClientGeneral"
                  :client-sid="clientSid"
                  :show-domain-conflict="subdomainConflicted"
                  @client-general-changed="onClientGeneralChanged"
                  @client-logo-changed="onClientLogoChanged"
                  @client-options-changed="onClientOptionsChanged"
                  @client-general-saved="onClientGeneralSaved"
                  @subdomain-changed="onSubdomainChanged"
                />
              </div>
            </v-tabs-window-item>
            <v-tabs-window-item :value="1">
              <client-excursion-management
                v-model:show-vendor-secret-key-conflict="vendorSecretKeyConflicted"
                v-model:show-vendor-client-sid-conflict="vendorClientSidConflicted"
                :client-sid="clientSid"
                @client-excursion-management-changed="onClientExcursionManagementChanged"
                @show-school-type-warning="onShowSchoolTypeWarning"
                @is-valid-school-type="onIsValidSchoolType"
                @client-excursion-management-saved="onclientExcursionManagementSaved"
              />
            </v-tabs-window-item>
            <v-tabs-window-item :value="2">
              <client-provider
                :client-sid="clientSid"
                @client-provider-changed="onClientProviderChanged"
                @client-provider-saved="onClientProviderSaved"
              >
              </client-provider>
            </v-tabs-window-item>
            <v-tabs-window-item :value="3">
              <client-content-engine
                ref="refClientContentEngine"
                :client-sid="clientSid"
                :subdomain="subdomain"
                :client-save-action-in-progress="clientSaveActionInProgress"
                @content-engine-changed="onClientContentEngineChanged"
                @content-engine-saved="onClientContentEngineSaved"
              >
              </client-content-engine>
            </v-tabs-window-item>
            <v-tabs-window-item :value="4">
              <client-student-management
                ref="refClientStudentManagement"
                :client-sid="clientSid"
                :school-types="schoolTypes"
                @student-management-saved="onClientStudentManagementSaved"
                @change-student-management-vendor-sid="changeActiveStudentManagementVendorSid"
                @student-management-changed="onStudentManagementChanged"
                @update:service-ended="onServiceEndedChanged"
                @update:valid="onStudentManagementValidChanged"
              />
            </v-tabs-window-item>
            <v-tabs-window-item :value="5">
              <v-row no-gutters>
                <v-col cols="12">
                  <v-icon size="small">mdi-information</v-icon>
                  <span>You can upload one file for client template.</span>
                </v-col>
                <v-col v-for="(proformaTemplateFile, index) in clientTemplateFiles" :key="index">
                  <v-row v-if="!proformaTemplateFile.isDeleted" dense>
                    <v-col cols="12">
                      <label :for="getUploadFileId('proformaTemplate', index)">
                        <input
                          :id="getUploadFileId('proformaTemplate', index)"
                          style="display: none"
                          type="file"
                          :accept="proformaTemplateFileExtensions"
                          @change="handleTemplateFileChange($event, proformaTemplateFile, index)"
                        />
                      </label>
                      <cs-button
                        :id="getUploadFileBtnId('proformaTemplate', index)"
                        primary
                        left-icon="mdi-upload"
                        label="Upload"
                        @click="uploadFileClick('proformaTemplate', index)"
                      />
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">File Name</span>
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">{{
                        proformaTemplateFile.filename
                      }}</span>
                      <v-icon
                        v-if="proformaTemplateFile.sid && !templateFileChanged"
                        :id="getDownloadFileBtnId('proformaTemplate', index)"
                        @click="downloadFile(proformaTemplateFile)"
                        >mdi-download
                      </v-icon>
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">Uploaded Date</span>
                    </v-col>
                    <v-col cols="12" class="px-2">
                      <span class="form-label template-file-font">
                        {{ getUploadDate(proformaTemplateFile.fileUpdateDate) }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tabs-window-item>
            <v-tabs-window-item :value="6">
              <client-hub-migration v-model:active-step="hubStep" :client-sid="clientSid" />
            </v-tabs-window-item>
          </v-tabs-window>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <div class="client-individual-error">
          {{ saveActionErrorMessage }}
        </div>
        <v-spacer></v-spacer>
        <cs-button
          id="btnSave"
          primary
          label="Save All"
          :disabled="saveButtonDisabled"
          :loading="clientSaveActionInProgress"
          @click="openSaveConfirmation()"
        ></cs-button>
      </v-card-actions>
    </v-card>
    <cs-form-dialog
      id="dlg-client-ind-editor-invalid-file-type"
      v-model="invalidFileTypeDialogDisplayed"
      body-id="dlg-client-ind-editor-invalid-file-type-body"
      heading="Client Individual Editor"
      :primary-action="{
        label: 'OK',
        eventName: 'primary-click'
      }"
      @primary-click="invalidFileTypeDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        Invalid File type:
        <span class="debug-error-message">{{ uploadFilename }}</span>
        <br />
        <span v-safe-html="invalidFileTypeAdditionalMessage"></span>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="dlg-client-ind-editor-generic"
      v-model="genericDialogDisplayed"
      body-id="dlg-client-ind-editor-generic-body"
      heading="Client Individual Editor"
      :primary-action="{
        label: 'OK',
        eventName: 'primary-click'
      }"
      @primary-click="genericDialogOkBtnClickHandle"
    >
      <template #cs-form-dialog-content>
        <div
          v-safe-html="genericDialogMessage"
          :class="isGenericDialogDisplayedAsError ? 'generic-error-message' : ''"
        ></div>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="confirm-save-form-dialog"
      v-model="confirmSaveDialogDisplayed"
      heading="Client Settings Editor"
      :primary-action="{
        label: 'Continue',
        eventName: 'primary-click'
      }"
      @primary-click="onConfirmSave"
    >
      <template #cs-form-dialog-content>
        <div>
          <group-mapping-summary
            :summary="groupMappingChangeSummary"
            :student-group-sync-diffs="groupMappingSyncDiffs"
          />
          <span>You are about to save the client settings. Are you sure you want to proceed?</span>
        </div>
      </template>
    </cs-form-dialog>
    <cs-form-dialog
      id="confirm-test-connection-failed-dialog"
      v-model="confirmTestConnectionFailedDialogDisplayed"
      heading="Client Settings Editor"
      :primary-action="{
        label: 'Continue',
        eventName: 'primary-click'
      }"
      @primary-click="save"
    >
      <template #cs-form-dialog-content>
        <div>
          <span>
            Failed to connect to the student management vendor based on the current settings. Please
            check your configuration and try again.
          </span>
          <br /><br />
          <span>Do you still want to proceed with saving?</span>
        </div>
      </template>
    </cs-form-dialog>
  </div>
</template>

<script>
import * as types from '@/store/mutationTypes';
import { required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import attachmentCategory from '../lib/const/attachmentCategory';
import dbEntityRelation from '../lib/const/dbEntityRelation';
import errorCaseSid from '../lib/const/errorCaseSid';
import providerSourceType from '../lib/const/providerSourceType';
import clientIndividualEditorSection from '../lib/const/clientIndividualEditorSection';
import ClientGeneral from './ClientGeneral';
import ClientContentEngine from './ClientContentEngine';
import ClientExcursionManagement from './ClientExcursionManagement';
import ClientProvider from './ClientProvider';
import ClientStudentManagement from './ClientStudentManagement';
import ClientHubMigration from './ClientHubMigration';
import cloneDeep from 'lodash/cloneDeep';
import GroupMappingSummary from './GroupMappingSummary';

function validateKebabCasedString(value) {
  const regex = /^([a-z0-9]*)([-.][a-z0-9]+)*$/;
  const kebabCasedStringValid = regex.test(value);
  return kebabCasedStringValid;
}

function validateSubmomain(value) {
  if (!value || (value && value.length === 0)) {
    return true;
  }
  const regex = /^[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})*$/;
  const subdomainValid = regex.test(value);
  return subdomainValid;
}

function validateUrl(value) {
  if (!value || (value && value.length === 0)) {
    return true;
  }
  const regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w-]+)+[\w\-_~:/?#[\]@!&',;=.]+$/;
  const urlValid = regex.test(value);
  return urlValid;
}

export default {
  name: 'ClientIndividualEditor',

  components: {
    ClientGeneral,
    ClientExcursionManagement,
    ClientContentEngine,
    ClientProvider,
    ClientStudentManagement,
    ClientHubMigration,
    GroupMappingSummary
  },

  emits: ['reloadClients'],

  setup: () => ({ v$: useVuelidate() }),

  validations() {
    return {
      clientName: {
        required
      },
      vendorClientSid: {
        required,
        validateKebabCasedString
      },
      timezone: {
        required
      },
      subdomain: {
        required,
        validateSubmomain
      },
      idpUrl: {
        validateIdpUrl: validateUrl
      },
      provider: {
        apiBaseUrl: {
          validateApiBaseUrl: validateUrl
        }
      }
    };
  },
  data() {
    return {
      studentVendorServiceEnded: false,
      studentManagementValid: true,
      propType: '',
      propClientSid: '',
      propClientIndividualModalRefreshed: true,
      activeSectionIndex: 0,
      excursionManagementVendorSharedSecretKey: '',
      auth0LoginEnabled: false,
      clientIndividualModalDisplayed: false,
      clientSid: '',
      clientName: '',
      csClientId: '-',
      vendorSid: null,
      vendorClientSid: '',
      vendorClientName: '',
      excursionManagementVendorWebhookUrl: '',
      clientLogoBackgroundColor: '',
      prevGetParent: 0,
      isValidSchoolType: true,
      isGenericDialogDisplayedAsError: false,
      genericDialogDisplayed: false,
      genericDialogMessage: '',
      vendorExcursionSidInputEnabled: false,
      boardingSupportEnabled: false,
      vendorClientSidConflicted: false,
      vendorSecretKeyConflicted: true,
      excursionAdditionalInformationEnabled: false,
      excursionChecklistEnforcementBeforeSubmissionEnabled: false,
      excursionCopyActionEnabled: false,
      excursionDestinationContentEnabled: false,
      excursionHighRiskStudentMedicalEnabled: false,
      excursionPersonResponsibleEnabled: false,
      excursionPolicyViewActionEnabled: false,
      excursionInherentRiskRatingEnabled: false,
      idpRbaclEnabled: false,
      publicSchoolFeatureSetEnabled: false,
      imgSrc: '',
      cropImg: '',
      logoFile: '',
      searchDomain: '',
      logoFileChanged: false,
      originalLogoUsed: true,
      contentEngine: {
        ceApiUri: '',
        xSiteUri: '',
        moduleName: ''
      },
      timezone: '',
      clientSaveActionInProgress: false,
      ceParamErrorDisplayed: false,
      subdomain: '',
      idpUrl: '',
      subdomainConflicted: false,
      activeStudentManagementVendorSid: null,
      studentManagement: {},
      studentManagementFileChanged: false,
      schoolTypes: [],
      savedSchoolTypes: [],
      selectedApplyParentId: null,
      applySubjectEnabled: false,
      applyCustomEnabled: false,
      clientTemplateFiles: [{}],
      invalidFileTypeDialogDisplayed: false,
      invalidFileTypeAdditionalMessage: '',
      selectedTemplateFile: {},
      proformaTemplateFileExtensions: `.pdf,.doc,.docx,.xls,.xlsx`,
      proformaTemplateFileMimeTypeAllowed: [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ],
      uploadFilename: '',
      templateFileChanged: false,
      provider: {},
      siteData: {},
      ceParamErrorMessage: 'Invalid Content Engine parameter',
      apiProviderParamErrorMessage: 'Invalid Api Provider parameter',
      saveActionErrorMessage: '',
      isClientSaved: false,
      confirmSaveDialogDisplayed: false,
      confirmTestConnectionFailedDialogDisplayed: false,
      hubStep: 1,
      groupMappingChangeSummary: null,
      groupMappingSyncDiffs: null
    };
  },
  computed: {
    vendorClientSidErrors() {
      const errors = [];
      if (this.vendorClientSidConflicted) {
        errors.push('Vendor Client SID conflicted');
      }
      return errors;
    },
    clientIndividualModalRefreshed() {
      return this.propClientIndividualModalRefreshed;
    },
    inputInvalid() {
      return this.v$.$invalid;
    },
    saveButtonDisabled() {
      const excursionManagementInValid =
        this.vendorClientSidConflicted || this.vendorSecretKeyConflicted;
      return (
        this.inputInvalid ||
        this.clientSaveActionInProgress ||
        !this.studentManagementValid ||
        !(
          this.contentEngine.ceApiUri &&
          this.contentEngine.xSiteUri &&
          this.contentEngine.moduleName
        ) ||
        !this.isValidSchoolType ||
        this.providerInvalid ||
        excursionManagementInValid
      );
    },
    providerInvalid() {
      return (
        this.provider.sourceType &&
        providerSourceType.API === this.provider.sourceType &&
        (!this.provider.apiBaseUrl ||
          !this.provider.apiKey ||
          !this.provider.apiTenantSid ||
          !this.provider.apiReportSid)
      );
    },
    subdomainErrors() {
      const errors = [];
      if (this.subdomainConflicted) {
        errors.push('Client Subdomain conflicted');
      }
      return errors;
    }
  },
  watch: {
    async clientIndividualModalRefreshed() {
      this.logoFileChanged = false;
      this.templateFileChanged = false;
      this.clientSid = this.propClientSid;
      await this.newClient(this.propClientSid);
      this.clientIndividualModalDisplayed = true;
    },
    '$route.query': {
      handler(val) {
        if (this.isClientSaved) return;
        this.updateQueryString(val);
      },
      deep: true,
      immediate: true
    },
    activeSectionIndex(val) {
      const searchQuery = {};
      searchQuery.section = this.getSectionNameByIndex(val);
      this.$router.replace({ query: searchQuery }, () => {});
    },
    hubStep(val) {
      if (val) {
        const searchQuery = cloneDeep(this.$route.query);
        searchQuery.hubStep = val;
        this.updateQueryString(searchQuery);
      }
    }
  },
  async mounted() {
    const { params } = this.$route;
    if (params && params.id) {
      this.propClientSid = params.id;
      this.propType = 'update';
    }

    this.logoFileChanged = false;
    this.templateFileChanged = false;
    const { axiosInstance, eventPluginCommonAdapter, stbApiAdapter } = this.$app;
    await this.$store.dispatch('authorisation/validateAndSetUserTokenOrLogout', {
      query: this.$route.query,
      axiosInstance
    });
    await this.$store.dispatch('common/initClientConfig', {
      eventPluginCommonAdapter,
      stbApiAdapter
    });

    this.logoFileChanged = false;

    this.clientSid = this.propClientSid;

    await this.newClient(this.propClientSid);
    this.clientIndividualModalDisplayed = true;

    this.updateQueryString();
  },
  methods: {
    async openSaveConfirmation() {
      const studentManagement = this.$refs.refClientStudentManagement;
      this.groupMappingChangeSummary =
        (await studentManagement?.previewGroupMappingChanges()) ?? null;
      this.groupMappingSyncDiffs = studentManagement?.getGroupSyncDiffs() ?? [];
      this.confirmSaveDialogDisplayed = true;
    },
    async newClient(clientSid) {
      this.vendorClientSidConflicted = false;
      this.vendorSecretKeyConflicted = false;
      this.subdomainConflicted = false;

      if (clientSid !== '' && undefined !== clientSid) {
        let auth0LoginEnabled = false;
        let vendorClientSid = '';
        let vendorClientName = '';
        let vendorExcursionSidInputEnabled = false;
        let boardingSupportEnabled = false;
        let excursionAdditionalInformationEnabled = false;
        let excursionChecklistEnforcementBeforeSubmissionEnabled = false;
        let excursionCopyActionEnabled = false;
        let excursionDestinationContentEnabled = false;
        let excursionHighRiskStudentMedicalEnabled = false;
        let excursionPersonResponsibleEnabled = false;
        let excursionPolicyViewActionEnabled = false;
        let excursionInherentRiskRatingEnabled = false;
        let clientLogoBackgroundColor = '';
        let provider = {};
        let excursionManagementVendorWebhookUrl = '';
        let excursionManagementVendorSharedSecretKey = '';
        let idpRbaclEnabled = false;
        let publicSchoolFeatureSetEnabled = false;

        // get logo
        const requestParam = {
          'vendor-sid': this.$store.state.common.apiParam['vendor-sid'],
          'oauth-signature': this.$store.state.common.apiParam['oauth-signature']
        };

        const argHash = {
          sid: this.clientSid,
          requestParam,
          store: this.$store
        };

        const cbResponse = await this.$app.stbApiAdapter.getClients(argHash);

        this.imgSrc = '';
        if (!cbResponse.error) {
          const client = cbResponse.data[0];

          if (client.cs_client_id) {
            this.csClientId = client.cs_client_id;
          }

          if (client.computed.logoAttachmentUrl) {
            this.cropImg = client.computed.logoAttachmentUrl;
          }

          auth0LoginEnabled = client.metadata.auth0LoginEnabled
            ? client.metadata.auth0LoginEnabled
            : false;

          const activeVendorSid = client.metadata.activeVendorSid
            ? client.metadata.activeVendorSid
            : '';

          excursionAdditionalInformationEnabled = client.metadata
            .excursionAdditionalInformationEnabled
            ? client.metadata.excursionAdditionalInformationEnabled
            : false;

          excursionChecklistEnforcementBeforeSubmissionEnabled = client.metadata
            .excursionChecklistEnforcementBeforeSubmissionEnabled
            ? client.metadata.excursionChecklistEnforcementBeforeSubmissionEnabled
            : false;

          excursionCopyActionEnabled = client.metadata.excursionCopyActionEnabled
            ? client.metadata.excursionCopyActionEnabled
            : false;

          excursionDestinationContentEnabled = client.metadata.excursionDestinationContentEnabled
            ? client.metadata.excursionDestinationContentEnabled
            : false;

          excursionHighRiskStudentMedicalEnabled = client.metadata
            .excursionHighRiskStudentMedicalEnabled
            ? client.metadata.excursionHighRiskStudentMedicalEnabled
            : false;

          excursionPolicyViewActionEnabled = client.metadata.excursionPolicyViewActionEnabled
            ? client.metadata.excursionPolicyViewActionEnabled
            : false;

          excursionInherentRiskRatingEnabled = client.metadata.excursionInherentRiskRatingEnabled
            ? client.metadata.excursionInherentRiskRatingEnabled
            : false;

          idpRbaclEnabled = client.metadata.idpRbaclEnabled
            ? client.metadata.idpRbaclEnabled
            : false;

          publicSchoolFeatureSetEnabled = client.metadata.publicSchoolFeatureSetEnabled
            ? client.metadata.publicSchoolFeatureSetEnabled
            : false;

          if (client.metadata.provider) {
            provider = client.metadata.provider;
          }

          const vendors = client[dbEntityRelation.VENDOR_LIST];
          if (activeVendorSid !== '') {
            const vendor = vendors.find((v) => v.sid === `${activeVendorSid}`);
            if (vendor) {
              if (vendor['vendor-client-sid']) {
                vendorClientSid = vendor['vendor-client-sid'];
              }

              if (vendor.join_metadata.vendorClientName) {
                vendorClientName = vendor.join_metadata.vendorClientName;
              }

              if (vendor.join_metadata.vendorExcursionSidInputEnabled) {
                vendorExcursionSidInputEnabled =
                  vendor.join_metadata.vendorExcursionSidInputEnabled;
              }

              if (vendor.join_metadata.boardingSupportEnabled) {
                boardingSupportEnabled = vendor.join_metadata.boardingSupportEnabled;
              }

              if (vendor.join_metadata.excursionPersonResponsibleEnabled) {
                excursionPersonResponsibleEnabled =
                  vendor.join_metadata.excursionPersonResponsibleEnabled;
              }

              if (vendor.join_metadata.clientLogoBackgroundColor) {
                clientLogoBackgroundColor = vendor.join_metadata.clientLogoBackgroundColor;
              }

              if (vendor.join_metadata.excursionManagementVendorWebhookUrl) {
                excursionManagementVendorWebhookUrl =
                  vendor.join_metadata.excursionManagementVendorWebhookUrl;
              }

              if (vendor.join_metadata.excursionManagementVendorSharedSecretKey) {
                excursionManagementVendorSharedSecretKey =
                  vendor.join_metadata.excursionManagementVendorSharedSecretKey;
              }
            }
          }

          this.auth0LoginEnabled = auth0LoginEnabled;
          this.clientLogoBackgroundColor = clientLogoBackgroundColor;
          this.clientName = client.metadata.name;
          this.excursionAdditionalInformationEnabled = excursionAdditionalInformationEnabled;
          this.excursionCopyActionEnabled = excursionCopyActionEnabled;
          this.excursionDestinationContentEnabled = excursionDestinationContentEnabled;
          this.excursionHighRiskStudentMedicalEnabled = excursionHighRiskStudentMedicalEnabled;
          this.excursionPersonResponsibleEnabled = excursionPersonResponsibleEnabled;
          this.excursionInherentRiskRatingEnabled = excursionInherentRiskRatingEnabled;
          this.idpRbaclEnabled = idpRbaclEnabled;
          this.publicSchoolFeatureSetEnabled = publicSchoolFeatureSetEnabled;
          this.excursionPolicyViewActionEnabled = excursionPolicyViewActionEnabled;
          this.excursionChecklistEnforcementBeforeSubmissionEnabled =
            excursionChecklistEnforcementBeforeSubmissionEnabled;
          this.provider = provider;
          this.vendorClientName = vendorClientName;
          this.vendorClientSid = vendorClientSid;
          this.vendorExcursionSidInputEnabled = vendorExcursionSidInputEnabled;
          this.boardingSupportEnabled = boardingSupportEnabled;
          this.vendorSid = client.metadata.activeVendorSid;
          this.excursionManagementVendorWebhookUrl = excursionManagementVendorWebhookUrl;
          this.excursionManagementVendorSharedSecretKey = excursionManagementVendorSharedSecretKey;
          this.activeStudentManagementVendorSid = client.metadata.activeStudentManagementVendorSid;

          if (this.activeStudentManagementVendorSid) {
            const studentVendor = vendors.find(
              (v) => v.sid === `${this.activeStudentManagementVendorSid}`
            );
            if (studentVendor?.join_metadata?.studentManagement) {
              this.studentManagement = cloneDeep(studentVendor.join_metadata.studentManagement);
              this.studentVendorServiceEnded = !!studentVendor.join_metadata.isVendorServiceEnded;
            }
          }

          this.contentEngine = {};
          if (client.metadata.contentEngine) {
            this.contentEngine = client.metadata.contentEngine;
            let { ceApiUri } = this.contentEngine;
            if (ceApiUri.substring(ceApiUri.length - 1) === '/') {
              ceApiUri = ceApiUri.substring(0, ceApiUri.lastIndexOf('/'));
            }
            this.contentEngine.ceApiUri = ceApiUri;
          }
          this.timezone = client.metadata.timezone ? client.metadata.timezone : '';
          this.subdomain = client.metadata.subdomain ? client.metadata.subdomain : '';
          this.idpUrl = client.metadata.idpUrl ? client.metadata.idpUrl : '';

          this.schoolTypes = [];
          if (client.metadata.schoolType) {
            const { schoolType } = client.metadata;
            Object.keys(schoolType).forEach((schoolKey) => {
              this.schoolTypes.push({
                id: schoolKey,
                name: schoolType[schoolKey]
              });
            });

            this.savedSchoolTypes = JSON.parse(JSON.stringify(this.schoolTypes));
          }

          // Get template file
          if (client.computed.templateAttachment) {
            const file = client.computed.templateAttachment;
            this.clientTemplateFiles[0].filename = file.metadata.filename;
            this.clientTemplateFiles[0].fileUpdateDate = file.created_at;
            this.clientTemplateFiles[0].sid = file.sid;
          }

          this.siteData = client.metadata.siteData || {};
        }
      } else {
        this.clear();
      }
    },
    genericDialogOkBtnClickHandle() {
      this.genericDialogDisplayed = false;
      this.isGenericDialogDisplayedAsError = false;

      if (this.isClientSaved) {
        this.$router.replace('/admin/clients').catch(() => {});
      }
    },
    async save() {
      this.confirmTestConnectionFailedDialogDisplayed = false;
      this.confirmSaveDialogDisplayed = false;
      this.vendorClientSidConflicted = false;
      this.vendorSecretKeyConflicted = false;
      this.subdomainConflicted = false;
      this.ceParamErrorDisplayed = false;
      this.saveActionErrorMessage = '';
      this.clientSaveActionInProgress = true;

      if (`${this.clientSid}` !== '' && this.studentManagementFileChanged) {
        const previewResult = await this.previewComplispaceStudentManagement(this.clientSid);
        if (previewResult && previewResult.error) {
          this.handleSaveError({ data: previewResult.error });
          this.alertSaveResult(previewResult);
          this.clientSaveActionInProgress = false;
          return;
        }
      }

      const apiParam = JSON.parse(JSON.stringify(this.$store.state.common.apiParam));
      const client = {
        auth0LoginEnabled: this.auth0LoginEnabled,
        clientLogoBackgroundColor: this.clientLogoBackgroundColor,
        contentEngine: this.contentEngine,
        excursionAdditionalInformationEnabled: this.excursionAdditionalInformationEnabled,
        excursionChecklistEnforcementBeforeSubmissionEnabled:
          this.excursionChecklistEnforcementBeforeSubmissionEnabled,
        excursionCopyActionEnabled: this.excursionCopyActionEnabled,
        excursionDestinationContentEnabled: this.excursionDestinationContentEnabled,
        excursionHighRiskStudentMedicalEnabled: this.excursionHighRiskStudentMedicalEnabled,
        excursionPersonResponsibleEnabled: this.excursionPersonResponsibleEnabled,
        excursionPolicyViewActionEnabled: this.excursionPolicyViewActionEnabled,
        excursionInherentRiskRatingEnabled: this.excursionInherentRiskRatingEnabled,
        idpRbaclEnabled: this.idpRbaclEnabled,
        publicSchoolFeatureSetEnabled: this.publicSchoolFeatureSetEnabled,
        name: this.clientName,
        provider: this.provider,
        timezone: this.timezone,
        vendorClientName: this.vendorClientName,
        vendorClientSid: this.vendorClientSid,
        vendorExcursionSidInputEnabled: this.vendorExcursionSidInputEnabled,
        boardingSupportEnabled: this.boardingSupportEnabled,
        excursionManagementVendorWebhookUrl: this.excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey: this.excursionManagementVendorSharedSecretKey,
        vendorSid: this.vendorSid,
        subdomain: this.subdomain,
        idpUrl: this.idpUrl,
        siteData: this.siteData
      };
      /*
      if (!cbGetClientIdentifiers.error) {
        client.csClientId = parsedClient.id;
      }
      */
      if (
        !client.contentEngine.ceApiUri &&
        !client.contentEngine.xSiteUri &&
        !client.contentEngine.moduleName
      ) {
        delete client.contentEngine;
      }

      const schoolType = {};
      this.schoolTypes.forEach((s) => {
        schoolType[s.id] = s.name;
      });
      client.schoolType = schoolType;

      const studentManagementData = this.mergeStudentManagementIntoClient();
      const hasStudentManagement = !!studentManagementData?.activeStudentManagementVendorSid;

      apiParam.metadata = {
        ...client,
        ...(hasStudentManagement ? studentManagementData : {})
      };

      if (apiParam.metadata.contentEngine) {
        delete apiParam.metadata.contentEngine.xAppKey;
        delete apiParam.metadata.contentEngine.xWebApiKey;
      }

      if (`${this.clientSid}` !== '') {
        if (this.templateFileChanged) {
          this.uploadClientTemplateFiles(this.clientSid);
        }

        const argHash = {
          sid: this.clientSid,
          payload: apiParam,
          store: this.$store
        };

        const cbResponse = await this.$app.stbApiAdapter.putClients(argHash);
        if (cbResponse.errorDetected) {
          this.handleSaveError(cbResponse);
          this.alertSaveResult(cbResponse);
        } else if (!cbResponse.error) {
          this.clientSid = cbResponse.data.sid;
          this.uploadClientTemplateFiles(this.clientSid);
          await this.saveLogo();
          this.alertSaveResult(cbResponse);
        } else {
          this.alertSaveResult(cbResponse);
        }
      } else {
        const apiArgHash = {
          payload: apiParam,
          store: this.$store
        };

        const cbResponse = await this.$app.stbApiAdapter.postClients(apiArgHash);
        if (cbResponse.errorDetected) {
          this.handleSaveError(cbResponse);
          this.alertSaveResult(cbResponse);
        } else if (!cbResponse.error) {
          this.clientSid = cbResponse.data.sid;
          this.uploadClientTemplateFiles(this.clientSid);

          await this.saveLogo(this.clientSid);
          this.alertSaveResult(cbResponse);
        } else {
          this.alertSaveResult(cbResponse);
        }
      }

      this.clientSaveActionInProgress = false;
    },

    handleSaveError(cbResponse) {
      if (cbResponse.data && ['400', '409'].indexOf(`${cbResponse.data.statusCode}`) !== -1) {
        switch (`${cbResponse.data.errorCaseSid}`) {
          case errorCaseSid.CLIENT_SUBDOMAIN_CONFLICTED:
            this.subdomainConflicted = true;
            [this.saveActionErrorMessage] = this.subdomainErrors;
            break;

          case errorCaseSid.VENDOR_CLIENT_SID_CONFLICTED:
            this.vendorClientSidConflicted = true;
            [this.saveActionErrorMessage] = this.vendorClientSidErrors;
            break;

          case errorCaseSid.CONTENT_ENGINE_PARAMETER_INVALID:
            this.ceParamErrorDisplayed = true;
            this.saveActionErrorMessage = this.ceParamErrorMessage;
            break;

          case errorCaseSid.PROVIDER_PARAMETER_INVALID:
            this.saveActionErrorMessage = this.apiProviderParamErrorMessage;
            break;

          case errorCaseSid.EXCURSION_VENDOR_SECRET_KEY_CONFLICTED:
            this.vendorSecretKeyConflicted = true;
            this.saveActionErrorMessage = 'Secret Key is conflicted';
            break;

          default:
            this.saveActionErrorMessage =
              cbResponse.data.message || `${cbResponse.data.errorCaseSid}`;
            break;
        }
      } else {
        this.saveActionErrorMessage = cbResponse.data
          ? `${cbResponse.data.statusCode}: ${cbResponse.data.message}`
          : 'Error while saving client';
      }
    },
    async saveLogo() {
      const saveLogoRes = await this.$refs.refClientGeneral.saveLogo(this.clientSid);
      if (!saveLogoRes || saveLogoRes.error) {
        this.alertSaveResult('error', 'General Setting saved, but logo failed to be saved.');
        this.saveActionInProgress = false;
        return false;
      }
      return true;
    },

    alertSaveResult(cbResponse) {
      this.isGenericDialogDisplayedAsError = false;
      this.clientIndividualModalDisplayed = false;
      this.genericDialogDisplayed = true;

      if (cbResponse && !cbResponse.errorDetected && !cbResponse.error && cbResponse.data) {
        // success
        this.genericDialogMessage = 'Client has been saved.';
        this.isClientSaved = true;
        this.clear();
        this.$emit('reloadClients');
      } else {
        // failed
        this.isClientSaved = false;
        this.isGenericDialogDisplayedAsError = true;
        this.genericDialogMessage = 'Failed to save Client information.';
      }
    },

    onSubdomainChanged() {
      this.subdomainConflicted = false;
      this.saveActionErrorMessage = '';
    },
    clear() {
      this.v$.$reset();
      this.auth0LoginEnabled = false;
      this.clientName = '';
      this.vendorSid = null;
      this.vendorClientSid = '';
      this.vendorClientName = '';
      this.vendorExcursionIdInputEnabled = false;
      this.excursionManagementVendorWebhookUrl = '';
      this.excursionManagementVendorSharedSecretKey = '';
      this.excursionPersonResponsibleEnabled = false;
      this.excursionAdditionalInformationEnabled = false;
      this.excursionChecklistEnforcementBeforeSubmissionEnabled = false;
      this.excursionCopyActionEnabled = false;
      this.excursionDestinationContentEnabled = false;
      this.excursionHighRiskStudentMedicalEnabled = false;
      this.excursionPolicyViewActionEnabled = false;
      this.excursionInherentRiskRatingEnabled = false;
      this.idpRbaclEnabled = false;
      this.publicSchoolFeatureSetEnabled = false;
      this.clientLogoBackgroundColor = '';
      this.contentEngine = {};
      this.timezone = '';
      this.clientSaveActionInProgress = false;
      this.ceParamErrorDisplayed = false;
      this.$store.commit(types.COMMON_RESET_PARENT_CLIENT);
      this.subdomain = '';
      this.idpUrl = '';
      this.activeStudentManagementVendorSid = null;
      this.studentManagementValid = true;
      this.studentVendorServiceEnded = false;
      this.vendorExcursionSidInputEnabled = false;
      this.boardingSupportEnabled = false;
      this.schoolTypes = [];
      this.savedSchoolTypes = [];
      this.isValidSchoolType = true;

      this.applySubjectEnabled = false;
      this.applyCustomEnabled = false;
      this.clientTemplateFiles = [{}];
      this.provider = {};
      this.saveActionErrorMessage = '';
    },

    close() {
      this.clear();
    },

    changeActiveStudentManagementVendorSid(studentManagementVendorSid) {
      this.activeStudentManagementVendorSid = studentManagementVendorSid;
    },
    getUploadFileId(category, index) {
      return `uploadFile__${category}__${index}`;
    },
    getUploadFileBtnId(category, index) {
      return `uploadFileBtn__${category}__${index}`;
    },
    getDownloadFileBtnId(category, index) {
      return `downloadFileBtn__${category}__${index}`;
    },
    uploadFileClick(category, index) {
      document.getElementById(`uploadFile__${category}__${index}`).click();
    },
    getUploadDate(uploadDate) {
      let timezoneDate = '';
      if (uploadDate) {
        const localDate = this.$app.moment(uploadDate);
        timezoneDate = this.$app
          .moment(localDate)
          .utc()
          .tz(this.$store.state.common.clientTimezone)
          .format('DD/MM/YYYY, hh:mm:ss A');
      }
      return timezoneDate;
    },
    handleTemplateFileChange(e, proformaTemplateFile) {
      if (e && e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        const filename = file.name;
        const fileType = file.type;
        const extensionType = filename.split('.').pop();

        if (
          this.proformaTemplateFileExtensions.indexOf(extensionType) < 0 ||
          !this.proformaTemplateFileMimeTypeAllowed.includes(fileType)
        ) {
          this.invalidFileTypeDialogDisplayed = true;
          this.uploadFilename = filename;
          e.target.value = '';
          this.invalidFileTypeAdditionalMessage = '';
          return;
        }

        // eslint-disable-next-line no-param-reassign
        proformaTemplateFile.file = file;
        // eslint-disable-next-line no-param-reassign
        proformaTemplateFile.filename = file.name;
        // eslint-disable-next-line no-param-reassign
        proformaTemplateFile.fileUpdateDate = '';
        this.$forceUpdate();
        this.templateFileChanged = true;
      }
    },
    async downloadFile(proformaTemplateFile) {
      const apiQuery = JSON.parse(JSON.stringify(this.$store.state.common.apiParam));

      const argHash = {
        queryParam: apiQuery,
        sid: proformaTemplateFile.sid,
        store: this.$store
      };
      const response = await this.$app.stbApiAdapter.getAttachments(argHash);
      if (response.data) {
        const attachments = response.data;
        if (attachments.length > 0) {
          const file = attachments[0];
          if (file && file.computed && file.metadata) {
            const filePath = file.computed.url.replace(/^\//, '');
            const apiUrl = this.$app.env.API_URL.replace(/\/$/, '');
            const fileUrl = `${apiUrl}/${filePath}`;
            const { filename } = file.metadata;
            const excursionCommonAdapter = new this.$app.excursionCommon.Adapter({
              store: this.$store,
              app: this.$app
            });
            excursionCommonAdapter.downloadFile(fileUrl, filename, this.$app.deviceDetector);
          }
        }
      }
    },
    async uploadClientTemplateFiles() {
      if (this.clientTemplateFiles && this.clientTemplateFiles.length > 0) {
        const fd = new FormData();
        fd.append('category', attachmentCategory.PROFORMA_TEMPLATE);
        const addTemplateFilesList = this.clientTemplateFiles.filter(
          (a) => typeof a.file !== 'undefined'
        );
        if (addTemplateFilesList && addTemplateFilesList.length > 0) {
          for (let i = 0; i < addTemplateFilesList.length; i += 1) {
            const proformaTemplateFile = addTemplateFilesList[i];
            fd.append('file', proformaTemplateFile.file);
          }
          const argHash = {
            sid: this.clientSid,
            payload: fd,
            store: this.$store
          };
          await this.$app.stbApiAdapter.postClientAttachmentCategories(argHash);
        }
      }
    },
    onStudentManagementChanged(payload) {
      if (!payload) {
        this.activeStudentManagementVendorSid = null;
        this.studentVendorServiceEnded = false;
        this.studentManagement = null;
        this.studentManagementFileChanged = false;
        return;
      }
      this.activeStudentManagementVendorSid = payload.activeStudentManagementVendorSid;
      this.studentVendorServiceEnded = payload.studentVendorServiceEnded;
      this.studentManagement = payload.studentManagement;
      this.studentManagementFileChanged = !!payload.studentManagementFileChanged;
    },

    async previewComplispaceStudentManagement(clientSid) {
      const ref = this.$refs.refClientStudentManagement;
      if (!ref?.hasComplispaceFileChanged?.()) {
        return { error: false };
      }

      const file = ref.getComplispaceFile();
      if (!file) {
        return { error: false };
      }

      this.$store.commit('app/setSilentAxiosError', true);
      try {
        const preview = await this.$store.dispatch(
          'clients/postClientStudentManagementGroupingCsvToJson',
          {
            clientSid,
            file
          }
        );
        if (preview && preview.error) {
          return preview;
        }

        if (preview?.schoolGroups?.length) {
          this.schoolTypes = preview.schoolGroups.map((s) => ({
            id: String(s.id),
            name: s.name
          }));
        }

        ref.setComplispacePreviewGrouping(
          preview.schoolGroups,
          preview.cocurriculumGroups,
          preview.allGroups
        );

        return { error: false };
      } catch (error) {
        return { error };
      } finally {
        this.$store.commit('app/setSilentAxiosError', false);
      }
    },

    mergeStudentManagementIntoClient() {
      const studentManagementData = {
        activeStudentManagementVendorSid: this.activeStudentManagementVendorSid,
        studentVendorServiceEnded: this.studentVendorServiceEnded,
        studentManagement: this.studentManagement
      };

      const ref = this.$refs.refClientStudentManagement;
      if (!ref?.collectStudentManagement) {
        return studentManagementData;
      }

      const sm = ref.collectStudentManagement();
      if (!sm?.activeStudentManagementVendorSid || !sm) {
        return {};
      }

      return {
        activeStudentManagementVendorSid: sm.activeStudentManagementVendorSid,
        studentVendorServiceEnded: sm.studentVendorServiceEnded,
        studentManagement: cloneDeep(sm.studentManagement)
      };
    },
    getSectionNameByIndex(index) {
      switch (index) {
        case 0:
          return clientIndividualEditorSection.GENERAL;
        case 1:
          return clientIndividualEditorSection.EXCURSION_MANAGEMENT;
        case 2:
          return clientIndividualEditorSection.PROVIDERS;
        case 3:
          return clientIndividualEditorSection.CONTENT_ENGINE;
        case 4:
          return clientIndividualEditorSection.STUDENT_MANAGEMENT;
        case 5:
          return clientIndividualEditorSection.TEMPLATES;
        case 6:
          return clientIndividualEditorSection.HUB_MIGRATION;
        default:
          return clientIndividualEditorSection.GENERAL;
      }
    },
    updateQueryString(query) {
      if (query) {
        this.$router.replace({ query }, () => {});
        return;
      }
      const searchQuery = {};
      searchQuery.section = clientIndividualEditorSection.GENERAL;
      searchQuery.hubStep = this.hubStep;
      if (Object.keys(this.$route.query).length !== 0) {
        const { section: parsedSection, hubStep: parsedHubStep } = this.$route.query;

        if (parsedSection && String(parsedSection).trim().length !== 0) {
          switch (parsedSection) {
            case clientIndividualEditorSection.GENERAL:
              this.activeSectionIndex = 0;
              break;
            case clientIndividualEditorSection.EXCURSION_MANAGEMENT:
              searchQuery.section = clientIndividualEditorSection.EXCURSION_MANAGEMENT;
              this.activeSectionIndex = 1;
              break;
            case clientIndividualEditorSection.PROVIDERS:
              searchQuery.section = clientIndividualEditorSection.PROVIDERS;
              this.activeSectionIndex = 2;
              break;
            case clientIndividualEditorSection.CONTENT_ENGINE:
              searchQuery.section = clientIndividualEditorSection.CONTENT_ENGINE;
              this.activeSectionIndex = 3;
              break;
            case clientIndividualEditorSection.STUDENT_MANAGEMENT:
              // The student-group table owns its own in-memory pagination/sort/search inside the
              // ClientStudentManagement subtree; the editor only restores the section selection.
              searchQuery.section = clientIndividualEditorSection.STUDENT_MANAGEMENT;
              this.activeSectionIndex = 4;
              break;
            case clientIndividualEditorSection.TEMPLATES:
              searchQuery.section = clientIndividualEditorSection.TEMPLATES;
              this.activeSectionIndex = 5;
              break;
            case clientIndividualEditorSection.HUB_MIGRATION:
              searchQuery.section = clientIndividualEditorSection.HUB_MIGRATION;
              if (parsedHubStep && !Number.isNaN(parseInt(parsedHubStep, 10))) {
                this.hubStep = parseInt(parsedHubStep, 10);
              }
              searchQuery.hubStep = this.hubStep;
              this.activeSectionIndex = 6;
              break;
            default:
              this.activeSectionIndex = 0;
          }
        }
      }

      this.$router.replace({ query: searchQuery }, () => {});
    },
    onClientGeneralChanged(clientGeneralData) {
      if (!clientGeneralData) {
        return;
      }
      const { clientName, subdomain, idpUrl, timezone } = clientGeneralData;
      this.clientName = clientName;
      this.timezone = timezone;
      this.idpUrl = idpUrl;
      this.subdomain = subdomain;
    },
    onClientLogoChanged(clientLogo) {
      if (!clientLogo) {
        return;
      }
      const { clientLogoBackgroundColor } = clientLogo;
      this.clientLogoBackgroundColor = clientLogoBackgroundColor;
    },
    onClientOptionsChanged(clientOptions) {
      const {
        excursionAdditionalInformationEnabled,
        auth0LoginEnabled,
        excursionCopyActionEnabled,
        excursionChecklistEnforcementBeforeSubmissionEnabled,
        excursionHighRiskStudentMedicalEnabled,
        excursionPersonResponsibleEnabled,
        excursionPolicyViewActionEnabled,
        excursionInherentRiskRatingEnabled,
        idpRbaclEnabled,
        publicSchoolFeatureSetEnabled
      } = clientOptions;

      this.auth0LoginEnabled = auth0LoginEnabled;
      this.excursionAdditionalInformationEnabled = excursionAdditionalInformationEnabled;
      this.excursionChecklistEnforcementBeforeSubmissionEnabled =
        excursionChecklistEnforcementBeforeSubmissionEnabled;
      this.excursionCopyActionEnabled = excursionCopyActionEnabled;

      this.excursionHighRiskStudentMedicalEnabled = excursionHighRiskStudentMedicalEnabled;
      this.excursionPersonResponsibleEnabled = excursionPersonResponsibleEnabled;

      this.excursionPolicyViewActionEnabled = excursionPolicyViewActionEnabled;
      this.excursionInherentRiskRatingEnabled = excursionInherentRiskRatingEnabled;
      this.idpRbaclEnabled = idpRbaclEnabled;
      this.publicSchoolFeatureSetEnabled = publicSchoolFeatureSetEnabled;
    },
    onClientGeneralSaved() {
      // go to Excursion Management section
      this.activeSectionIndex = 1;
    },
    onClientContentEngineChanged(contentEngine) {
      const { ceApiUri, xSiteUri, moduleName } = contentEngine;
      this.contentEngine = { ceApiUri, xSiteUri, moduleName };
    },
    onClientContentEngineSaved() {
      // go to Student Management section
      this.activeSectionIndex = 4;
    },
    onClientExcursionManagementChanged(excursionManagement) {
      const {
        vendorSid,
        vendorClientSid,
        vendorClientName,
        excursionManagementVendorWebhookUrl,
        excursionManagementVendorSharedSecretKey,
        vendorExcursionSidInputEnabled,
        boardingSupportEnabled,
        schoolTypes
      } = excursionManagement;
      this.vendorSid = vendorSid;
      this.vendorClientSid = vendorClientSid;
      this.vendorClientName = vendorClientName;
      this.excursionManagementVendorWebhookUrl = excursionManagementVendorWebhookUrl;
      this.excursionManagementVendorSharedSecretKey = excursionManagementVendorSharedSecretKey;
      this.vendorExcursionSidInputEnabled = vendorExcursionSidInputEnabled;
      this.boardingSupportEnabled = boardingSupportEnabled;
      this.schoolTypes = schoolTypes;
      this.saveActionErrorMessage = '';
    },
    onShowSchoolTypeWarning() {
      this.genericDialogDisplayed = true;
      this.isGenericDialogDisplayedAsError = true;
      this.genericDialogMessage = 'Doing school type changes may cause issues in PlanCheckGo!';
    },
    onIsValidSchoolType(isValidSchoolType) {
      this.isValidSchoolType = isValidSchoolType;
    },
    onClientProviderChanged(provider) {
      const { sourceType, clientApiProvider, clientSftpProvider } = provider;
      if (sourceType === providerSourceType.API) {
        const {
          baseUrl: apiBaseUrl,
          tenantSid: apiTenantSid,
          apiKey,
          reportSid: apiReportSid
        } = clientApiProvider;
        this.provider = { sourceType, apiBaseUrl, apiTenantSid, apiKey, apiReportSid };
      } else if (sourceType === providerSourceType.SFTP) {
        const { sftpPath } = clientSftpProvider;
        this.provider = { sourceType, sftpPath };
      } else {
        this.provider = {};
      }
    },
    onClientProviderSaved() {
      // go to Content Engine section
      this.activeSectionIndex = 3;
    },
    async onclientExcursionManagementSaved() {
      this.activeSectionIndex = 2;
      // temporarily calling this to refresh the group mapping to adapt to schoolType changes
      await this.newClient(this.propClientSid);
    },
    async onClientStudentManagementSaved() {
      this.activeSectionIndex = 5;
    },
    onServiceEndedChanged(serviceEnded) {
      this.studentVendorServiceEnded = serviceEnded;
    },
    onStudentManagementValidChanged(valid) {
      this.studentManagementValid = valid;
    },
    async onConfirmSave() {
      this.confirmSaveDialogDisplayed = false;
      this.confirmTestConnectionFailedDialogDisplayed = false;

      const canProceed = this.$refs.refClientStudentManagement
        ? await this.$refs.refClientStudentManagement.testConnectionBeforeSave()
        : true;

      if (canProceed) {
        this.save();
      } else {
        this.confirmTestConnectionFailedDialogDisplayed = true;
      }
    }
  }
};
</script>
<style scoped>
.client-edit-form {
  min-height: 70vh;
}

.buildIndexContainer {
  display: flex;
  align-items: center;
  color: green;
}

.noIndexBuild {
  color: red;
}

.studentGroupId {
  color: gray;
}

.generic-error-message {
  color: rgb(var(--v-theme-error));
}

.client-individual-error {
  color: #ff0000;
  padding-left: 32px;
}

.client-individual-editor :deep(.v-field__clearable .mdi-close) {
  color: rgb(var(--v-theme-primary));
}

.client-individual-editor :deep(.table-header) {
  font-size: 12px !important;
  font-weight: bolder !important;
  color: #000 !important;
}
</style>
